import { useState, useEffect } from 'react';
import './index.css';
import Navbar from './components/Navbar';
import ScrollProgress from './components/ScrollProgress';
import Home from './components/Home';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Resume from './components/Resume';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SectionDots from './components/SectionDots';
import CommandPalette from './components/CommandPalette';

function App() {
  const [cmdOpen, setCmdOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setCmdOpen(o => !o);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  return (
    <div className="App">
      <div className="bg-canvas" aria-hidden="true">
        <div className="bg-blob bg-blob-1" />
        <div className="bg-blob bg-blob-2" />
        <div className="bg-blob bg-blob-3" />
      </div>
      <ScrollProgress />
      <Navbar onCmdOpen={() => setCmdOpen(true)} />
      <Home />
      <div className="section-divider" />
      <Skills />
      <div className="section-divider" />
      <Experience />
      <div className="section-divider" />
      <Projects />
      <div className="section-divider" />
      <Resume />
      <div className="section-divider" />
      <Contact />
      <Footer />
      <SectionDots />
      <CommandPalette open={cmdOpen} onClose={() => setCmdOpen(false)} />
    </div>
  );
}

export default App;
